import { monthNames } from "../d3-services/_formats";
var HtmlPeriodSelector = /** @class */ (function () {
    function HtmlPeriodSelector(element, graphSlug) {
        this.element = element;
        this.graphSlug = graphSlug;
    }
    HtmlPeriodSelector.prototype.draw = function (data) {
        var selectEl = this.element.querySelector('.period_select_' + this.graphSlug);
        if (selectEl) {
            selectEl.parentNode.removeChild(selectEl);
        }
        var dropdown = document.createElement('select');
        dropdown.classList.add('period_select_' + this.graphSlug);
        dropdown.style.alignSelf = 'flex-start';
        var option = document.createElement('option');
        option.label = 'Doorlopend';
        option.value = 'all';
        option.innerText = 'Doorlopend';
        dropdown.appendChild(option);
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var month = data_1[_i];
            option = document.createElement('option');
            option.label = monthNames[month._month - 1] + ' ' + month._year;
            option.value = month._yearmonth;
            option.innerText = 'Maand';
            dropdown.appendChild(option);
        }
        dropdown.style.border = '1px solid black';
        dropdown.style.margin = '-1rem 0 2rem .5rem';
        dropdown.style.borderRadius = '0';
        var headerElement = this.element.querySelector('.article_header');
        this.element.insertBefore(dropdown, headerElement.nextSibling);
    };
    HtmlPeriodSelector.prototype.redraw = function () {
    };
    return HtmlPeriodSelector;
}());
export default HtmlPeriodSelector;
